import { IntegrationType, NonSensitiveFlightRecordConnectedAccount } from "@nova/schemas"
import classNames from "classnames"
import { HTMLAttributes } from "react"
import { ConnectedAccount } from "./ConnectedAccount"
import { ContextMenuItem } from "features/data-management/workspace/TODO-put-in-package/ContextMenu"

export const ConnectedAccountIntegrationSection = <I extends IntegrationType>({
    type,
    accounts,
    onSync,
    createContextMenuSections,
    ...rest
}: {
    type: I
    accounts: NonSensitiveFlightRecordConnectedAccount<I>[]
    createContextMenuSections: (
        account: NonSensitiveFlightRecordConnectedAccount<I>
    ) => ContextMenuItem[][]
    onSync: (id: string) => void
} & HTMLAttributes<HTMLDivElement>) => {
    return (
        <div key={type} {...rest} className={classNames("flex items-start pb-8", rest.className)}>
            <small className="xs text-gray-0 w-[12%] min-w-20 truncate shrink-0">{type}</small>

            <div className="flex flex-col min-w-[500px] flex-grow">
                {accounts?.map((account, i) => {
                    const contextMenuSections = createContextMenuSections(account)
                    return (
                        <ConnectedAccount
                            key={account.id}
                            account={account}
                            className={classNames({
                                "border-t border-gray-700 pt-6": i > 0,
                                "pb-6": accounts.length > 1 && i < accounts.length - 1,
                            })}
                            onSync={onSync}
                            contextMenuSections={contextMenuSections}
                        />
                    )
                })}
            </div>

            {/* Spacer */}
            <div className="w-[12%] min-w-20 shrink-0" />
        </div>
    )
}
